var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"terms-page"},[_c('PageTitle',{attrs:{"title":"TERMS OF SERVICE"}}),_c('Terms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }